module.exports = __webpack_public_path__ + "static/media/stamp_mask_h.29bb5d36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stamp_mask_h.svg
// module id = 602
// module chunks = 0